var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box text-center",class:{ 'mode-bottom': _vm.mode == 'bottom' }},_vm._l((_vm.items),function(t){return _c('div',{key:t.index,staticClass:"cell",class:{ 'cell-opacity': _vm.opacity },style:({ 'background-color': t.Color })},[_vm._v("\n    "+_vm._s(_vm.getThresholdText(_vm.items, t))+"%\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }